let date = new Date();
export default {
    dateType: 1,
    dates: [
        '' + (date.getDate() > 9 ? '' : '0') + date.getDate() + '.' + (date.getMonth() > 8 ? '' : '0') + (date.getMonth() + 1) + '.' + date.getFullYear(),
        '' + (date.getDate() > 9 ? '' : '0') + date.getDate() + '.' + (date.getMonth() > 8 ? '' : '0') + (date.getMonth() + 1) + '.' + date.getFullYear()
    ],
    SumFrom: 0,
    SumTo: 0,
    AvailableSumFrom: 0,
    AvailableSumTo: 0,
    CurrencyIds: [],
    ContragentId: '',
    ContragentName: '',
    ContragentSearchTypeId: '',
    Number: '',
    Type: '',
    OwnerLegalEntityId: '',
    IsUsed: false,
    IsPayed: false,
}